<template>
  <v-layout column >
    <v-layout  fill-height>
      <v-flex xs12 mt-5 pt-5>
        <v-flex v-if="!loading" class="headline text-xs-center">Loading...</v-flex>
      </v-flex>
    </v-layout>

    <v-dialog v-model="switchAccountDialog" persistent :width="$store.getters.getAppWidth - 10">
      <v-card>
        <v-toolbar dark color="primary" pr-0>
          <v-toolbar-title>Signup</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn style="display:contents;"
                   dark flat @click="logout()"><span class="notranslate"><v-icon>close</v-icon></span></v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-flex>Hello again, {{userFullName}}!</v-flex>
          <v-flex mt-2>You already have a Cogneti user account (<strong><em>{{email}}</em></strong>).</v-flex>
          <v-flex mt-2>Please confirm your registration now for the
            <strong>Safe Food Handler</strong> certificate program.</v-flex>
          <v-flex mt-2>After registration, a welcome email will be sent with a
            certificate program overview and other instructions.</v-flex>
        </v-card-text>
        <v-card-actions>
          <v-layout column>
            <v-flex px-5>
              <v-btn color="success" block @click="registerSfh">Register</v-btn>
            </v-flex>
            <v-flex mt-3 px-5 text-xs-center>
              <em>By selecting <strong>REGISTER</strong> you accept the <a target="__blank" href="https://www.cogneti.com/terms-of-use">Cogneti License</a> terms.</em>
            </v-flex>
            <v-flex pt-3 pb-5 px-2>
              If any of the above personal
              information needs updating, use the Settings page after signing into the certificate program app.
            </v-flex>
          </v-layout>

        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="creationLoaderDialog"
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Please wait. Your account is being created...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
// import ScrollData from '../ScrollData'
// import Header from '../layouts/Header'
import {mapGetters, mapMutations} from 'vuex'
import crypto from '@/mixins/crypto'

export default {
  name: 'Programs',
  // components: {Header, ScrollData},
  data () {
    return {
      creationLoaderDialog: false,
      footer: false,
      courseId: process.env.GAME_ID,
      apiUrl: process.env.API_URL,
      switchAccountDialog: false,
      loading: true,
      registerLoading: true,
      email: localStorage.getItem('email') || null,
      userFullName: ''
    }
  },
  computed: {
    ...mapGetters('registration', ['getUserDetails']),
    isManager () {
      const role = this.$store.getters['user/getCourses'][process.env.GAME_ID].role.toLowerCase()
      return role === 'region manager' || role === 'district manager' || role === 'restaurant'
    },
    groups: function () {
      return this.$store.getters['course/getGroups']
    },
    userId () {
      return this.user.id ? this.user.id : 0
    },
    user () {
      return this.$store.getters['user/getUserDetails']
    },
    currentGroup () {
      const filteredGroups = this.groups.reduce((a, b) => {
        const deck = b.decks.find(deck => deck.regId === this.courseId)
        if (deck) {
          return [...a, b]
        }
        return a
      }, [])
      return filteredGroups[0]
    }
  },
  mounted () {
    this.initPage()
  },
  methods: {
    ...mapMutations('registration', [
      'setUser'
    ]),
    registerSfh () {
      // COPY OF 52 GetNameAndPwd
      const gameId = +process.env.GAME_ID
      this.creationLoaderDialog = true
      this.$store.commit('setLoadingDialog', true, {root: true})
      this.$http({
        url: process.env.API_URL + '/ws/userservice/course/' + gameId + '/register',
        method: 'POST',
        data: {
          'firstName': null,
          'lastName': null,
          'password': null,
          'email': localStorage.getItem('email'),
          'client': null,
          'otpId': null,
          'country': null,
          'state': null,
          'app': null,
          'platform': null
        }
      }).then(() => {
        this.creationLoaderDialog = false
        this.$store.commit('setLoadingDialog', false, {root: true})
        this.$store.commit('flashSuccess', 'You are now registered with Safe Food Handler certificate program.')
        this.logout()
      }, error => {
        this.creationLoaderDialog = false
        this.$store.commit('setLoadingDialog', false, {root: true})
        this.$store.commit('flashError', error.message, {root: true})
        this.creationLoaderDialog = false
      }).catch(error => {
        this.creationLoaderDialog = false
        this.$store.commit('setLoadingDialog', false, {root: true})
        this.$store.commit('flashError', error.message, {root: true})
      })
    },
    logout () {
      this.$auth.logout({
        redirect: '/',
        makeRequest: false
      })
    },
    isSfh () {
      return [52, 62, 68].includes(+process.env.GAME_ID)
    },
    initPage () {
      // eslint-disable-next-line no-console
      console.log('INIT PAGE')
      if (localStorage.getItem('email')) {
        this.$store.dispatch('registration/checkEmailExists', localStorage.getItem('email')).then(response => {
          // eslint-disable-next-line no-console
          // console.log('registration/checkEmailExists', response.data, response.data.userState, process.env.GAME_ID)
          if (response.data.userState === 1 && this.isSfh()) {
            // registered with some other course
            this.switchAccountDialog = true
            this.loading = true
            this.userFullName = response.data.firstName + ' ' + response.data.lastName
            this.email = response.data.email
            // eslint-disable-next-line no-console
            // console.log(response.data.firstName + ' ' + response.data.lastName)
          } else if (response.data.userState === 2 && this.isSfh()) {
            // this.$store.dispatch('course/fetchAvailablePrograms')
            // this.goToProgramLevel()
          }
        })
      }

      if (this.groups.length === 0) {
        // eslint-disable-next-line no-console
        console.log('INIT DASHBOARD')
        this.initiateDashboard()
      } else {
        console.log('GO TO PROGRAM LEVELS')
        this.goToProgramLevel()
      }
    },
    goToProgramLevel () {
      const group = this.currentGroup
      // eslint-disable-next-line no-console
      console.log({group, 'this.userId': this.userId})
      if (group) {
        if (this.userId) {
          // eslint-disable-next-line no-console
          console.log(202)
          this.redirect(group)
          return true
        }
      } else {
        this.$store.dispatch('course/fetchAvailablePrograms')
        setTimeout(() => {
          // eslint-disable-next-line no-console
          console.log(210)
          window.location.refresh()
        }, 7000)
      }
    },

    isProgramDetailPage () {
      return this.groups.length === 1 || typeof this.$route.params.deckId !== 'undefined'
    },
    initiateDashboard () {
      if (this.groups.length === 0) {
        this.$store.dispatch('course/fetchAvailablePrograms')
      }
    },
    checkIfUserIsRegistered () {
      const group = this.currentGroup

      if (group) {
        if (this.userId) {
          this.redirect(group)
        }
      }
    },
    redirect (group) {
      const deckId = group.decks[0].id
      const groupId = group.groupId
      // eslint-disable-next-line no-console
      console.log({deckId, groupId})
      this.$router.push({name: 'ProgramLevels68', params: {deckId, groupId}}).catch((e) => {
        // eslint-disable-next-line no-console
        console.log({e})
      })
    }
    // completeProfile () {
    //   const data = {
    //     'first_name': this.user.firstName,
    //     'last_name': this.user.lastName,
    //     'name_verified': false,
    //     'email': this.encryptData(this.user.email),
    //     'email_verified': true,
    //     'email_otp_generated': false,
    //     'country': this.user.countryId,
    //     'state': this.user.stateId,
    //     'profile_image': this.apiUrl + this.user.userImageUrl
    //   }
    //   this.setUser({...this.getUserDetails, ...data})
    //   const group1 = this.groups.find(group => group.decks[0].regId === 52)
    //   // eslint-disable-next-line no-console
    //   console.log('GROUP', group1)
    //   // IT is for RCA to SFH ONLY
    //   if (!group1) {
    //     this.$router.push({name: 'SignUp', params: {step: 'get-name-and-pwd', email: this.encryptData(this.user.email)}})
    //   }
    // }
  },
  watch: {
    userId (val) {
      if (val) {
        this.initPage()
      }
    },
    groups () {
      if (this.groups.length > 0) {
        this.checkIfUserIsRegistered()
      }
    }
  },
  mixins: [crypto]
}
</script>




// WEBPACK FOOTER //
// src/components/views/Programs/Programs68.vue